import { MessageCircle } from "lucide-react";

const WA_NUMBER = "543821452181";

export default function WhatsAppFab() {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
    "Hola! Necesito ayuda con una recarga de Free Fire"
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-black font-semibold px-4 py-3 rounded-full shadow-[0_8px_30px_rgba(16,185,129,0.4)]"
      style={{ transition: "transform 200ms ease, background-color 200ms ease" }}
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Soporte WhatsApp</span>
    </a>
  );
}
